import { AttributesMixin, Collection, define, Model, type } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { PaymentVaultCard } from "./paymentVaultCard";

export interface PaymentsVaultPage extends AttributesMixin<typeof PaymentsVaultPage> { }
@define
export class PaymentsVaultPage extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/assets');
    static idAttribute = "assetId";


    static attributes = {
        assetId: String,
        sortBy: {
          name: 'createdOn',
          isAsc: false
        },

        payments: type({items: [PaymentVaultCard], count: Number }).endpoint(restfulIO('./')).dontSave,
        selected: Collection.ofRefs(PaymentVaultCard)
    }
}